define([
    "jquery",
    "wow/wow",
    "models/product",
    "models/order",
    "pages/home/_faq-home",
    ], function($, WOW, ProductModel, OrderModel, FAQHome) {
        "use strict";

        return App.View.extend({
            el: "body",

            events: {
                "click .js-header-buy": "goToBuy",
            },

            initialize: function() {
                new WOW.WOW({
                    offset: 100,
                }).init();
                this.faqs = new FAQHome();
            },
            goToBuy: function(e) {
                if ($(".js-section-shop").length) {
                    e.preventDefault();
                    $("html, body").animate({
                        scrollTop: $(".js-section-shop").offset().top - 40
                    }, 1000);
                }
            },
            render: function () {
                var $header = $('.header');
                var height = $('.header').height();

                if (window.scrollY >= height) {
                    $header.addClass('fixedTop');
                }

                $(window).scroll(function(){
                    if($(this).scrollTop()>= height){
                        $header.addClass('fixedTop');
                    } else {
                        $header.removeClass('fixedTop');
                    }
                });

            }
        });
    });
